import React from 'react';

import { useApiClient } from '@eluve/api-client-provider';
import { P, VStack, legacyTextStyles } from '@eluve/components';
import {
  useAppointmentId,
  useAppointmentPatient,
  useAppointmentStatus,
  useListenForAppointmentLlmJobStatus,
  useListenForAppointmentPatient,
  useTenantId,
} from '@eluve/frontend-appointment-hooks';
import { DbEnums } from '@eluve/graphql-types';
import { patientOverviewSchema } from '@eluve/llm-outputs';

export const Situation: React.FC = () => {
  const patient = useAppointmentPatient();
  const appointmentId = useAppointmentId();
  const tenantId = useTenantId();
  const apiClient = useApiClient();
  const apptStatus = useAppointmentStatus();

  const { status } = useListenForAppointmentLlmJobStatus({
    outputType: DbEnums.LlmOutputType.PATIENT_OVERVIEW,
    shouldSubscribe: apptStatus === DbEnums.AppointmentStatus.NOT_STARTED,
  });

  useListenForAppointmentPatient();

  const patientOverviews = patient?.patient_overviews ?? [];
  const currentPatientOverview = patientOverviews.find(
    (overview) => overview.isCurrent,
  );
  const parsedOverview = patientOverviewSchema.safeParse(
    currentPatientOverview?.content ?? '',
  );

  if (!parsedOverview.success) {
    return null;
  }

  return (
    <VStack
      wFull
      align="stretch"
      className="rounded-xl border border-border-primary bg-bg-secondary  p-4"
    >
      <P className={legacyTextStyles.body({ size: 'm', weight: 'semibold' })}>
        Situation
      </P>
      <P
        className={`${legacyTextStyles.body({ size: 'm' })} ${
          status === DbEnums.WorkerStatus.IN_PROGRESS
            ? 'animate-pulse opacity-30'
            : ''
        }`}
      >
        {parsedOverview.data.details.join('\n')}
      </P>
    </VStack>
  );
};
